export default class PostLoader {
  constructor({ id, template, posts, container, btn }) {
    for (const [key, value] of Object.entries(arguments[0]))
      this[`_${key}`] = value;

    this._idx = 0;    
    this._size = parseInt(window["appData"].data?.appData?.posts_per_page);
    
    if (isNaN(this._size))
      this._size = 0;

    this._curr = [];    
    this._btn?.addEventListener("click", this.onBtnClick.bind(this));

    this._library = document.getElementById("library");
    this._node = this._library.content.getElementById(
      `template-post-${this._template}`
    );

    this._loading = false;
    this._timing = 0;
    this._timingIncrement = 50;    
  }

  onBtnClick(e) {    
    e.preventDefault();    
    if (this._loading) return;

    this._timing = 0;

    if (!this._btn.classList.contains("is-hidden"))
      this._btn.classList.add("is-hidden");

    this._curr = this._posts.slice(this._idx, this._size + this._idx);

    this.renderPosts();

    this._idx += this._size;
    this._next = this._posts.slice(this._idx, this._size + this._idx);    
  }

  renderPosts() {
    this._curr.forEach((p, i) => {
      const post = this._node.cloneNode(true);
      const img = post.querySelector(".post-thumb img");
      const meta = post.querySelector(".post-meta span");
      const title = post.querySelector(".post-title");
      const excerpt = post.querySelector(".post-content");

      post.removeAttribute("id");
      post.href = p.url;
      post.target = "_self";
      post.setAttribute("aria-label", p.title);

      img?.setAttribute("src", p.thumb);      
      
      meta.textContent = p.date;
      title.textContent = p.title;
      excerpt.textContent = p.excerpt;

      setTimeout(() => {
        this._container.appendChild(post);
        this._loading = i !== this._curr.length - 1;

        if (!this._loading) {
          if (!(this._next.length > 0)) this._btn?.remove();
          else this._btn.classList.remove("is-hidden");
        }
      }, this._timing);

      setTimeout(
        () => post.classList.remove("is-hidden"),
        this._timing + this._timingIncrement
      );

      this._timing += this._timingIncrement;
    });
  }
}
